import React, { useState } from "react";
import GenreCheckbox from "./GenreCheckbox";
import musics from "../../../../public/locals/music.json";
import "./styles.scss";
import { abstractString } from "../../../../api/helper";

const static_music_genre = musics.types.map((m, i) => {
  return { id: i + 1, name: m };
});

export default props => {
  const [genres, setGenres] = useState(props.defaultChecked || []);

  const onChangeHandler = e => {
    const { value } = e.target;
    let updatedGenres = [...genres];
    updatedGenres = updatedGenres.includes(value)
      ? updatedGenres.filter(g => g !== value)
      : [...updatedGenres, value];
    props.onChange(updatedGenres);
    setGenres(updatedGenres);
  };

  let music_genre_arr = static_music_genre;

  if (props.filterBy && props.filterBy === "selected") {
    music_genre_arr = static_music_genre.filter(g =>
      props.defaultChecked.includes(g.name)
    );
  }

  music_genre_arr = music_genre_arr.map(genre => (
    <GenreCheckbox
      id={`${genre.name}_${props.index ? props.index : 0}`}
      name={props.name || "music_genre"}
      key={genre.id}
      text={genre.name}
      onChange={onChangeHandler}
      disabled={props.disabled}
      defaultChecked={genres.some(
        g => abstractString(g) === abstractString(genre.name)
      )}
    />
  ));
  return (
    <div className="music-genres mb-4 pl-3">
      <div className={`d-flex ${props.noWrap ? "flex-nowrap" : "flex-wrap"}`}>
        {music_genre_arr}
      </div>
    </div>
  );
};
